import type { StoreCatalogItem, StoreCatalogPartnerRef } from './types'

type PartnerLookup = Record<string, string>

const toPartnerRef = (
  id: number | string | undefined | null,
  label: string | undefined | null
): StoreCatalogPartnerRef | null => {
  if (id == null || !label?.trim()) return null

  return {
    id: String(id),
    label: label.trim()
  }
}

/**
 * Parceiro da recompensa pai — usado no badge do card da listagem.
 * Ignora `reward_item.partner`: um reward sem parceiro pode ter variações
 * de parceiros distintos, e o badge só identifica loja de parceiro no reward.
 */
export const resolveRewardPartner = (
  item: StoreCatalogItem,
  partnerNameById: PartnerLookup = {}
): StoreCatalogPartnerRef | null => {
  const rewardPartnerId = item.reward?.partner_id ?? item.reward?.partner?.id
  const rewardPartnerName =
    item.reward?.partner?.name ?? partnerNameById[String(rewardPartnerId ?? '')]

  return toPartnerRef(rewardPartnerId, rewardPartnerName)
}

/**
 * Parceiro efetivo para filtro do catálogo:
 * `reward_item.partner` primeiro; fallback para `reward.partner`.
 * Nomes vêm do embed da API ou do lookup em `partnerNameById`.
 */
export const resolveItemPartner = (
  item: StoreCatalogItem,
  partnerNameById: PartnerLookup = {}
): StoreCatalogPartnerRef | null => {
  const itemPartnerId = item.partner_id ?? item.partner?.id
  const itemPartnerName =
    item.partner?.name ?? partnerNameById[String(itemPartnerId ?? '')]

  const fromItem = toPartnerRef(itemPartnerId, itemPartnerName)
  if (fromItem) return fromItem

  return resolveRewardPartner(item, partnerNameById)
}
